import { useQuery } from '@tanstack/react-query'

import { usersPasswordResetCheckGet } from '@src/api'
import { DefaultApiUsersPasswordResetCheckGetRequest } from '@src/api/generated/iam'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchUsersPasswordResetCheck = (
  params: DefaultApiUsersPasswordResetCheckGetRequest
) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useQuery({
    queryFn: () => usersPasswordResetCheckGet(axiosInstance, params),
    enabled: !!params.token,
    queryKey: [REACT_QUERY_CACHE_KEYS.USERS_PASSWORD_RESET_CHECK_GET, params],
  })
}
